import React, { useState, useRef, useEffect } from 'react';

const InlineInput = ({ onSend, disabled }) => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!disabled) inputRef.current?.focus({ preventScroll: true });
  }, [disabled]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  const submit = () => {
    if (value.trim() && !disabled) {
      onSend(value.trim());
      setValue('');
    }
  };

  return (
    <div className="w-full flex items-center gap-3 group">
      <div className="flex-1 relative">
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          placeholder="Type here…"
          className="w-full bg-transparent border-0 border-b-2 outline-none text-[15px] text-gray-800 placeholder-gray-300 pb-2 pt-1 transition-all duration-300 focus:placeholder-gray-200"
          style={{ borderBottomColor: value.trim() ? '#543e18' : '#e5e7eb' }}
        />
        <div
          className="absolute bottom-0 left-0 h-0.5 transition-all duration-500 ease-out rounded-full"
          style={{
            width: value.trim() ? '100%' : '0%',
            background: 'linear-gradient(90deg, #543e18, #a07840)',
          }}
        />
      </div>
      <button
        onClick={submit}
        disabled={!value.trim() || disabled}
        className="flex-shrink-0 transition-all duration-200"
        style={{ opacity: value.trim() && !disabled ? 1 : 0.3 }}
      >
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
          <circle cx="14" cy="14" r="14" fill={value.trim() && !disabled ? '#543e18' : '#d1d5db'} />
          <path d="M9 14.5l4 4 6-8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
};

export default InlineInput;